import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useMe } from '../api/hooks'
import { Spinner } from './ui'

/** Gates a route behind a login, remembering where the user was headed. */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { data: user, isPending } = useMe()
  const location = useLocation()

  if (isPending) return <Spinner />
  if (!user) {
    // `state.from` lets the login page send them onward rather than dumping
    // everyone on the dashboard.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return <>{children}</>
}
